export default "__VITE_ASSET__988398e5__"